import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import Ranking_1st from "../assets/images/Ranking_1st.svg";
import Ranking_2nd from "../assets/images/Ranking_2nd.svg";
import Ranking_3rd from "../assets/images/Ranking_3rd.svg";

const TopRanks = ({rankData, gender}) => {
    const ranking_1st = rankData[gender]?.find(data => data.rank === 1);
    const ranking_2nd = rankData[gender]?.find(data => data.rank === 2);
    const ranking_3nd = rankData[gender]?.find(data => data.rank === 3);

    return (
        <TopRanksWrapper>
            <div>
                    <BigImageItem>
                        <Link to={`/rank/${ranking_1st.id}`} state={{ list: ranking_1st }}>
                            <TopRankImage src={Ranking_1st} alt="rankFirst" style={{ width: "72px" }}/>
                            <TopRankSignerImage src={ranking_1st.image} alt="rankFirst"/>
                            <TopRankInfo>
                                <h6><span>{ranking_1st.score}</span>점</h6>
                                <h3>
                                    {ranking_1st.name}
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M17.8964 12.2161C17.9104 12.1441 17.9114 12.0731 17.9114 12.0001C17.9114 11.9261 17.9104 11.8561 17.8964 11.7841C17.8824 11.7131 17.8564 11.6471 17.8294 11.5791C17.8004 11.5071 17.7704 11.4391 17.7274 11.3741C17.7104 11.3491 17.7064 11.3191 17.6884 11.2951C17.6574 11.2551 17.6134 11.2351 17.5784 11.2011C17.5444 11.1671 17.5244 11.1241 17.4864 11.0941L10.9284 5.9931C10.4274 5.6031 9.70441 5.6941 9.31441 6.1951C8.92441 6.6961 9.01441 7.4191 9.51641 7.8091L14.9064 12.0001L9.51541 16.1921C9.01441 16.5831 8.92341 17.3051 9.31341 17.8061C9.54041 18.0971 9.87941 18.2501 10.2224 18.2501C10.4694 18.2501 10.7174 18.1711 10.9274 18.0081L17.4854 12.9071C17.4874 12.9061 17.4874 12.9041 17.4894 12.9021C17.5614 12.8451 17.6284 12.7801 17.6874 12.7051C17.7064 12.6811 17.7104 12.6511 17.7264 12.6261C17.7694 12.5601 17.8004 12.4921 17.8284 12.4201C17.8564 12.3531 17.8834 12.2881 17.8964 12.2161Z" fill="#ABB6BA"/>
                                    </svg>
                                </h3>
                            </TopRankInfo>
                        </Link>
                    </BigImageItem>
                <SmallImageItem>
                        <div>
                            <Link to={`/rank/${ranking_2nd.id}`} state={{ list: ranking_2nd }}>
                                <TopRankImage src={Ranking_2nd} alt="rankSecond" style={{ width: "40px" }}/>
                                <TopRankSignerImage src={ranking_2nd.image} alt="rankSecond"/>
                                <TopRankInfo>
                                    <h6><span>{ranking_2nd.score}</span>점</h6>
                                    <h3>
                                        {ranking_2nd.name}
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M17.8964 12.2161C17.9104 12.1441 17.9114 12.0731 17.9114 12.0001C17.9114 11.9261 17.9104 11.8561 17.8964 11.7841C17.8824 11.7131 17.8564 11.6471 17.8294 11.5791C17.8004 11.5071 17.7704 11.4391 17.7274 11.3741C17.7104 11.3491 17.7064 11.3191 17.6884 11.2951C17.6574 11.2551 17.6134 11.2351 17.5784 11.2011C17.5444 11.1671 17.5244 11.1241 17.4864 11.0941L10.9284 5.9931C10.4274 5.6031 9.70441 5.6941 9.31441 6.1951C8.92441 6.6961 9.01441 7.4191 9.51641 7.8091L14.9064 12.0001L9.51541 16.1921C9.01441 16.5831 8.92341 17.3051 9.31341 17.8061C9.54041 18.0971 9.87941 18.2501 10.2224 18.2501C10.4694 18.2501 10.7174 18.1711 10.9274 18.0081L17.4854 12.9071C17.4874 12.9061 17.4874 12.9041 17.4894 12.9021C17.5614 12.8451 17.6284 12.7801 17.6874 12.7051C17.7064 12.6811 17.7104 12.6511 17.7264 12.6261C17.7694 12.5601 17.8004 12.4921 17.8284 12.4201C17.8564 12.3531 17.8834 12.2881 17.8964 12.2161Z" fill="#ABB6BA"/>
                                        </svg>
                                    </h3>
                                </TopRankInfo>
                            </Link>
                        </div>
                        <div>
                            <Link to={`/rank/${ranking_3nd.id}`} state={{ list: ranking_3nd }}>
                                <TopRankImage src={Ranking_3rd} alt="rankThird" style={{ width: "40px" }} />
                                <TopRankSignerImage src={ranking_3nd.image} alt="rankThird"/>
                                <TopRankInfo>
                                    <h6><span>{ranking_3nd.score}</span>점</h6>
                                    <h3>
                                        {ranking_3nd.name}
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M17.8964 12.2161C17.9104 12.1441 17.9114 12.0731 17.9114 12.0001C17.9114 11.9261 17.9104 11.8561 17.8964 11.7841C17.8824 11.7131 17.8564 11.6471 17.8294 11.5791C17.8004 11.5071 17.7704 11.4391 17.7274 11.3741C17.7104 11.3491 17.7064 11.3191 17.6884 11.2951C17.6574 11.2551 17.6134 11.2351 17.5784 11.2011C17.5444 11.1671 17.5244 11.1241 17.4864 11.0941L10.9284 5.9931C10.4274 5.6031 9.70441 5.6941 9.31441 6.1951C8.92441 6.6961 9.01441 7.4191 9.51641 7.8091L14.9064 12.0001L9.51541 16.1921C9.01441 16.5831 8.92341 17.3051 9.31341 17.8061C9.54041 18.0971 9.87941 18.2501 10.2224 18.2501C10.4694 18.2501 10.7174 18.1711 10.9274 18.0081L17.4854 12.9071C17.4874 12.9061 17.4874 12.9041 17.4894 12.9021C17.5614 12.8451 17.6284 12.7801 17.6874 12.7051C17.7064 12.6811 17.7104 12.6511 17.7264 12.6261C17.7694 12.5601 17.8004 12.4921 17.8284 12.4201C17.8564 12.3531 17.8834 12.2881 17.8964 12.2161Z" fill="#ABB6BA"/>
                                        </svg>
                                    </h3>
                                </TopRankInfo>
                            </Link>
                        </div>
                </SmallImageItem>
            </div>
        </TopRanksWrapper>
    )
}

export default TopRanks;

const TopRanksWrapper = styled.div`
  margin: 16px auto 0 auto;
  display: flex;
  justify-content: center;
  max-width: 480px;
  height: 274px;

  & > div {
    display: flex;
    flex-direction: row;
    height: inherit;
    border-radius: 16px;
    overflow: hidden;
    margin: 0 16px;
  }
`;

const BigImageItem = styled.div`
  position: relative;
  height: inherit;
  cursor: pointer;

  h6 {
    font-weight: 500;
    font-size: 17px;
    line-height: 20px;
    letter-spacing: -0.25px;
  }
  
  h3 {
    font-weight: 600;
    font-size: 20px;
    line-height: 24px;
    letter-spacing: -0.15px;
  }
`;

const SmallImageItem = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 137px;
  cursor: pointer;

  & > div {
    position: relative;
    flex: 1;
  }

  & > div > img:nth-child(1) {
    width: 40px;
    height: 40px;
  }

  h6 {
    font-weight: 500;
    font-size: 15px;
    line-height: 18px;
    letter-spacing: -0.25px;
  }

  h3 {
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
    letter-spacing: -0.25px;
  }
`;

const TopRankSignerImage = styled.img`
  //height: 100%;
  object-fit: cover;
  width: 100%;
  height: 100%;
`;

const TopRankImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
`;

const TopRankInfo = styled.div`
  position: absolute;
  bottom: 3%;
  left: 3%;
  color: #fff;
  
   & > h3 {
     display: flex;
     align-items: center;
     
     & > svg {
       width: 16px;
       height: 16px;
       
       path {
         fill: #FFF;
       }
     }
   }
`;